import { render, staticRenderFns } from "./TermosPendentes.vue?vue&type=template&id=f73f90b6&scoped=true&"
import script from "./TermosPendentes.vue?vue&type=script&lang=js&"
export * from "./TermosPendentes.vue?vue&type=script&lang=js&"
import style0 from "./TermosPendentes.vue?vue&type=style&index=0&id=f73f90b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73f90b6",
  null
  
)

export default component.exports